import { render, staticRenderFns } from "./CheckboxQuestion.vue?vue&type=template&id=b2bb7956&scoped=true&"
import script from "./CheckboxQuestion.vue?vue&type=script&lang=js&"
export * from "./CheckboxQuestion.vue?vue&type=script&lang=js&"
import style0 from "./CheckboxQuestion.vue?vue&type=style&index=0&id=b2bb7956&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2bb7956",
  null
  
)

export default component.exports